<template>
  <div class="container container-small container-expand bg-light2">
    <AccentHeader
      :header="formData.header"
      :underline="true"
      :uppercase="false"
    />
    <form action="#"
          method="post"
          @submit.prevent="sendContactForm(contactFormData)"
          class="contact-form-wrapper"
          novalidate>

      <div class="contact-form-respond bg-light2"
           v-if="inMsgProgress || isMsgSent">
        <div class="text-s" v-if="inMsgProgress && !isMsgSent">
          {{ formData.progressMsg }}
        </div>
        <div class="text-l" v-if="isMsgSent">
          {{msgSentLabel}}
        </div>
      </div>

      <div class="contact-form-msg">
        <textarea name="msg-content"
                  ref="msg-content"
                  v-model="contactFormData['msg-content']"
                  cols="30"
                  rows="10"
                  :placeholder="formData.msg.placeholder">
        </textarea>
      </div>
      <div class="contact-form-list">
        <fieldset class="form-wrapper">
          <ul class="form-items">
            <li>
              <label for="msg-name">
                {{ formData.input.name }} <span class="accent">*</span>
              </label>
              <input type="text"
                     name="msg-name"
                     ref="msg-name"
                     v-model="contactFormData['msg-name']"
                     :placeholder="formData.input.placeholder" />
            </li>
            <li>
              <label for="msg-surname">
                {{ formData.input.surname }}
              </label>
              <input type="text"
                     name="msg-surname"
                     ref="msg-surname"
                     v-model="contactFormData['msg-surname']"
                     :placeholder="formData.input.placeholder" />
            </li>
            <li>
              <label for="msg-email">
                {{ formData.input.email }} <span class="accent">*</span>
              </label>
              <input type="email"
                     name="msg-email"
                     ref="msg-email"
                     v-model="contactFormData['msg-email']"
                     :placeholder="formData.input.placeholder" />
            </li>
          </ul>
        </fieldset>
      </div>
      <div class="contact-form-submit">
        <ul class="form-items-inline">
          <li>
            <label class="checkbox-item">
              <input type="checkbox"
                     name="msg-accepted-terms"
                     ref="msg-accepted-terms"
                     value="true"
                     v-model="contactFormData['msg-accepted-terms']" />
              <span class="checkbox-item-label text-xs">
                {{ formData.accept.terms }}
                <router-link :to="{ name: 'regulations'}">
                  {{ formData.accept.termsLink }}
                </router-link>
              </span>
            </label>
          </li>
          <li>
            <label class="checkbox-item">
              <input type="checkbox"
                     name="msg-accepted-rodo"
                     ref="msg-accepted-rodo"
                     value="true"
                     v-model="contactFormData['msg-accepted-rodo']" />
              <span class="checkbox-item-label text-xs">
                {{ formData.accept.gdpr }}
              </span>
            </label>
          </li>
        </ul>
        <div class="contact-form-submit-btn">
          <button type="submit"
                  class="btn-simple">
            <span>{{ formData.button }}</span>
          </button>
        </div>
      </div>
      <div v-if="msgErrors.length" class="contact-form-submit">
        <div class="alert alert-error">
          <h5 class="alert-title accent">
            {{ errors.title }}
          </h5>
          <ul class="alert-desc list-clean">
            <li v-for="(error, index) in msgErrors" :key="'error-' + index">
              {{error}}
            </li>
          </ul>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { apiUrl } from '@/api/config'
import axios from 'axios'
import AccentHeader from '@/components/AccentHeader.vue'

export default {
  name: 'contactForm',
  props: ['formData', 'errors'],
  components: {
    AccentHeader
  },
  data: function () {
    return {
      contactFormData: {
        'msg-content': '',
        'msg-name': '',
        'msg-surname': '',
        'msg-email': '',
        'msg-accepted-terms': false,
        'msg-accepted-rodo': false
      },
      msgErrors: [],
      inMsgProgress: false,
      isMsgSent: false,
      msgSentLabel: ''
    }
  },
  methods: {
    validateInput (id, value) {
      const emailRegex = /^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i

      switch (id) {
        case 'msg-content':
          if (value.length < 3) {
            this.msgErrors.push(this.errors.emptyMsg)
          }
          break
        case 'msg-name':
          if (!value.length || value.length < 2) {
            this.msgErrors.push(this.errors.emptyName)
          }
          break
        case 'msg-email':
          if (value.length < 2) {
            this.msgErrors.push(this.errors.emptyEmail)
          } else {
            if (!emailRegex.test(value)) {
              this.msgErrors.push(this.errors.incorrectEmail)
            }
          }
          break
        case 'msg-accepted-terms':
        case 'msg-accepted-rodo':
          if ((!value || value === 'false') && !this.msgErrors.includes(this.errors.noApproval)) {
            this.msgErrors.push(this.errors.noApproval)
          }
          break
      }
    },
    validateForm (data) {
      this.msgErrors = []
      for (var key in data) {
        this.validateInput(key, data[key])
      }
      return this.msgErrors.length
    },
    sendContactForm (postData) {
      if (!postData) { return false }
      if (this.validateForm(postData) < 1) {
        let formData = new FormData()

        this.inMsgProgress = true

        Object.keys(postData).map((key) => {
          if (postData[key]) {
            formData.append(key, postData[key])
          }
        })

        axios.post(`${apiUrl}contactForm`, formData, {
          headers: { 'Content-Type': 'multipart/form-data' }
        }).then(() => {
          this.isMsgSent = true
          this.msgSentLabel = this.formData.successMsg
          this.contactFormData = {
            'msg-content': '',
            'msg-name': '',
            'msg-surname': '',
            'msg-email': '',
            'msg-accepted-terms': false,
            'msg-accepted-rodo': false
          }

          setTimeout(() => {
            this.inMsgProgress = false
            this.isMsgSent = false
          }, 3000)
        }).catch((_err) => {
          console.log('Contact Form / ' + _err)
          this.isMsgSent = true
          this.msgSentLabel = this.formData.errorMsg

          setTimeout(() => {
            this.inMsgProgress = false
            this.isMsgSent = false
          }, 3000)
        }) // END axios.post();
      }
    } // END sendContactForm(postData);
  },
  computed: {
    ...mapGetters([
      'apiPath'
    ])
  },
  mounted () {
    this.msgSentLabel = this.formData.successMsg
  },
  watch: {
    apiPath (oldVal, newVal) {
      if (oldVal !== newVal) {
        this.msgErrors = []
      }
    }
  }
}
</script>

<style scoped lang="scss">
</style>
